import React from "react";

export default function AverageSalesData({
  averageSalesCountPerStorePerWeek,
  productChartsUrl,
}) {
  return (
    <div>
      <strong>
        <a href={productChartsUrl}>
          ø {parseFloat(averageSalesCountPerStorePerWeek).toFixed(2)}
        </a>
      </strong>
      <small>Abverkäufe pro Markt pro Woche</small>
    </div>
  );
}
